<ul class="breadcrumbs">
    <li class="breadcrumb">{{label}}</li>
    <li *ngFor="let breadcrumb of breadcrumbs" class="breadcrumb">{{breadcrumb}}</li>
</ul>
